import { NgxLoggerLevel } from "ngx-logger";

export const environment = {
  production: true,
  hostUrl:'',
  logLevel: NgxLoggerLevel.ERROR,
  serverLogLevel: NgxLoggerLevel.INFO ,
  enableSourceMaps: true,
  disableConsoleLogging: false,
};